module.exports = __webpack_public_path__ + "static/media/Battle Goddess.34e29d7c.jpg";